import React from 'react';
import { FormattedMessage } from 'react-intl';

import Form from 'react-bootstrap/Form';
import { Tooltip } from 'react-bootstrap';
import InputTooltip from './InputTooltip';

/**
 * Textarea components.
 *
 * @param {Object} props configs of Textarea
 */
const textarea = props => {
  const { label, required, error, tip, valid, changed } = props;

  let errorMessage = <Form.Text className="empty-field-info">&nbsp;</Form.Text>;

  if (!valid && error) {
    errorMessage = (
      <Form.Text className="error-message-small text-danger">
        <FormattedMessage id={`form.field.${label}.error`} />
      </Form.Text>
    );
  }

  return (
    <Form.Group controlId={label}>
      <Form.Label className={required ? 'field-required' : null}>
        <FormattedMessage id={`form.field.${label}.label`} />
      </Form.Label>
      {tip && (
        <InputTooltip>
          <Tooltip>
            <FormattedMessage id={`form.field.${label}.tip`} />
          </Tooltip>
        </InputTooltip>
      )}
      <Form.Control
        className={valid ? null : 'is-invalid'}
        as="textarea"
        onChange={changed}
        required={required}
        rows="3"
      />
      {errorMessage}
    </Form.Group>
  );
};

export default textarea;
